import { posToDOMRect } from "@tiptap/core";
import { ReelsSmall } from "@wix/wix-ui-icons-common";
import { TIPTAP_GIF_TYPE } from "./../ricos-content/index.js";
import { quickActionsModalSections, RicosPluginToolbarNames } from "./../ricos-types/index.js";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common/index.js";
import { pluginFigure } from "../plugin-figure/editor.js";
import { DEFAULT_CONFIGS, gifModals } from "./constants.js";
import { gifConverter } from "./converter/gif-converter.js";
import { getAddButtons } from "./getAddButtons.js";
import { getToolbarButtons } from "./getToolbarButtons.js";
import { GiphyInsertModal } from "./modals/InsertModal.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { GIPHY_TYPE } from "./types.js";
const pluginGiphy = (config) => {
  const pluginConfig = { ...DEFAULT_CONFIGS.editor, ...config };
  return {
    config: pluginConfig,
    pmMarkConverters: [],
    pmNodeConverters: [gifConverter],
    type: GIPHY_TYPE,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    toolbar: {
      names: [RicosPluginToolbarNames.GIF],
      getButtons: (config2, services) => getToolbarButtons(config2, services),
      resolveReferenceElement: (tiptapEditor) => {
        const startNodePos = tiptapEditor.state.selection.$from;
        if (startNodePos.nodeAfter?.type.name !== TIPTAP_GIF_TYPE) {
          return null;
        }
        return tiptapEditor.view.nodeDOM(startNodePos.pos - 1);
      }
    },
    getQuickActions: ({ config: config2, pluginServices }) => [
      {
        id: "giphy",
        title: "GIF",
        icon: ReelsSmall,
        section: quickActionsModalSections.Media,
        tags: ["animation", "motion", "clip", "short", "funny", "meme", "loop"],
        command: ({ modalService, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          modalService.togglePluginPanel({
            id: gifModals.insert,
            Component: GiphyInsertModal,
            componentProps: {
              modalId: gifModals.insert,
              getGiphyUrl: config2?.getGiphyUrl
            },
            isMobile: pluginServices?.context.isMobile,
            positioning: {
              referenceElement: {
                getBoundingClientRect: () => posToDOMRect(
                  editor.view,
                  editor.view.state.selection.from,
                  editor.view.state.selection.to
                )
              },
              placement: "bottom-end"
            }
          });
        }
      }
    ],
    dependencies: [pluginFigure],
    __exports: {
      InsertModal: GiphyInsertModal
    }
  };
};
export {
  pluginGiphy
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
